/**
 * Registers /sw.js (src/pwa/sw.ts) in production builds. Deliberately plain:
 * no "update available, reload?" prompt, because the worker fetches
 * index.html network-first and takes over on install, so a deploy reaches
 * the user the same way it always has (next load, or lazyWithRetry's reload).
 *
 * Checks for a newer worker once an hour and whenever the tab comes back
 * into view, so an installed app that stays open for days still picks up
 * the latest worker.
 */
const CHECK_EVERY_MS = 60 * 60 * 1000;

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/", updateViaCache: "none" })
      .then((registration) => {
        const check = () => registration.update().catch(() => {});
        window.setInterval(check, CHECK_EVERY_MS);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") check();
        });
      })
      .catch(() => {
        // No worker = the app works exactly as before; nothing to tell the user.
      });
  });
}
